import * as actions from "./actions";
import reducer from "./reducer";
import * as sagas from "./sagas";
import * as constants from "./constants";
import {
  ViewContext,
  UserContext,
  GAContextProps
} from "../common/google_analytics";
import { Publication } from "./constants";
import { AnalyticsContainer } from "./components";
import { merchants } from "./selectors";

export {
  AnalyticsContainer,
  reducer,
  actions,
  sagas,
  constants,
  merchants,
  ViewContext,
  UserContext,
  GAContextProps,
  Publication
};



// WEBPACK FOOTER //
// ./client/modules/Analytics/index.ts